<template>
  <div class="account-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="账号姓名" prop="staff">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delStaff(index)" v-for="(value, index) in form.staff" :key="index">{{value.name}}</a-tag>
        </div>
      </a-form-model-item>
     
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.staff" :data="tree.data" :params="tree.params"></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import OrganizationService from '@/io/organization.js';
  import CommunityService from '@/io/community.js';
  import RoleService from '@/io/role.js';
  import AccountService from '@/io/account.js';

  export default {
    name: 'AccountInfo',
    data() {
      return {
        id: this.$route.params.id,
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'backupId'
          }
        },
        modal: {
          title: '选择人员',
          show: false,
          staff: []
        },
        rangeOptions: [],
        roleOptions: [],
        form: {
          staff: [],
          type: null,
          role: [],
          range: []
        },
        rules: {
          staff: [
            {
              required: true,
              message: '请选择人员'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择账号类型'
            }
          ],
          role: [
            {
              required: true,
              message: '请选择管理角色'
            }
          ],
          range: [
            {
              required: true,
              message: '请选择管理范围'
            }
          ]
        }
      }
    },
    mounted () {
      Promise.all([
        this.initTreeData(),
      ]).then(() => {
      });
    },
    
    methods: {
      confirmModal() {
        this.modal.show = false;
        this.form.staff = this.$createNewVariable(this.modal.staff);
      },
      showModal() {
        this.modal.show = true;
        this.modal.staff = this.$createNewVariable(this.form.staff);
      },
      delStaff(index) {
        this.form.staff.splice(index, 1);
      },
      
      initTreeData() {
        return OrganizationService.companyStaffList().then(res => {
          this.$depthSearchTree(node => {
            if (node.type === 1) {
              node.disabled = true;
              node.backupId = `d-${node.id}`;
            } else {
              node.backupId = `s-${node.id}`;
            }
          }, res);
          this.tree.data = res;
        }).catch(err => {});
      },
    
      cancel() {
        this.$router.push('/platform/account_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>